export interface Dataset {
    id: string,
    text: string,
}

export interface Play {
    id: number,
    gid: string,
    score: number,
    rank: number,
}

export interface Story {
    id: number,
    title: string,
    lines: string,
    status: boolean,
    used: number,
    completed: number,
    fastest: number,
    average: number,
    suki: number,
    group_id: number,
    moji: number,
}

export interface ResultSet {
    story:Story,
    play:Play,
    is_suki:boolean,
}

export class Inc {
    static readonly groupNames:string[] = [
        "ラブ",
        "ナンセンス",
        "猟奇",
        "","","","","","",
        "その他",
    ];
    static readonly defaultPlay = ()=>{
        const play:Play = {
            id: 0,
            gid: "",
            score: 0,
            rank: 0,
        }
        return play;
    }
    static readonly defaultStory = ()=>{
        const story:Story = {
            id: 0,
            title: "",
            lines: "",
            used: 0,
            completed: 0,
            fastest: 0,
            average: 0,
            suki: 0,
            moji: 0,
            status: false,
            group_id: 0,
        }
        return story;
    }
    static readonly defaultResultSet = ()=>{
        const resultset:ResultSet = {
            play: Inc.defaultPlay(),
            story: Inc.defaultStory(),
            is_suki: false,
        }
        return resultset;
    }

}